import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function AdviceCard() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.portfolio.advice.title')}</Box>
        </Box>
      </Box>
      <Box
        mt={1}
        height={'100%'}
        width={'100%'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Box textAlign={'center'} width={'100%'}>
          {/* LAP-733 (GE022) */}
          {t('investments.portfolio.advice.future')}
        </Box>
        <Box textAlign={'right'} width={'100%'} pr={'10%'} mt={6}>
          {t('investments.portfolio.advice.signature') /* LAP-733 (GE022) */}
        </Box>
      </Box>
    </Box>
  )
}
